import { GlobalElementsConfig, LineOfBusinessConfig, PageBrand } from '../types'

const geConfig: GlobalElementsConfig = {
  header: 'about',
  footer: 'about',
}

const pageBrand: PageBrand = 'corporate'

export const corporate = new LineOfBusinessConfig(geConfig, pageBrand)
